import DefaultBlock from "../components/main/DefaultBlock";
import { Grid, Typography } from "@mui/material";
import { Button, Box } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link as RouterLink } from "react-router-dom";

import BigText from "../components/main/BigText";
import BlueprintBlock from "../components/main/BlueprintBlock";
import Profile from "../components/main/Profile";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { IconButton, Tooltip } from "@mui/material";
import Portfolios from "../components/main/Portfolios";
import ScrollingLogos from "../components/misc/ScrollingLogos";
import BlogColumn from "../components/main/BlogColumn";
import SEO from "../components/misc/SEO";

export default function Main() {
  return (
    <div>
      <SEO title="Home | Aaron Hunt" />
      <BlueprintBlock text="export default function App() {" />
      <DefaultBlock>
        <Grid container sx={{ width: "100%" }}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              width: { md: "50%" },
              boxSizing: "border-box",
              pr: { md: 1 },
            }}
          >
            <BigText
              first="Here to help with your"
              array={[
                "Frontend Design",
                "UI/UX Design",
                "Game Design",
                "3D Design",
              ]}
              last="needs!"
            />
            <Typography sx={{ px: 2, maxWidth: "512px", opacity: 0.8 }}>
              Whether you're building a game, a product, or something in
              between, I’m here to help.
            </Typography>

            <Box sx={{ px: 2, mt: 3, display: "flex", gap: 2 }}>
              {[
                {
                  label: "Work Examples",
                  to: "/work",
                  color: "primary",
                },
                { label: "About Me", to: "/blog/about-me", color: "secondary" },
              ].map(({ label, to, color }) => (
                <Button
                  key={label}
                  variant="contained"
                  color={color}
                  component={RouterLink}
                  to={to}
                  endIcon={<ArrowForwardIosIcon sx={{ height: 14 }} />}
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    "& .MuiButton-endIcon": {
                      opacity: 0.6,
                      transform: "translateX(-2px)",
                      transition: "all 0.3s ease",
                    },
                    "&:hover .MuiButton-endIcon": {
                      opacity: 1,
                      transform: "translateX(2px)",
                    },
                  }}
                >
                  {label}
                </Button>
              ))}
            </Box>
            <Box sx={{ display: "flex", gap: 1.5, px: 2, mt: 4, opacity: 0.6 }}>
              <Tooltip title="GitHub">
                <IconButton
                  component="a"
                  href="https://github.com/anhuntz/aaron-hunt-portfolio"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <GitHubIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="LinkedIn">
                <IconButton
                  component="a"
                  href="https://www.linkedin.com/in/aaron-h-36332412b/"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <LinkedInIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="YouTube">
                <IconButton
                  component="a"
                  href="https://www.youtube.com/@aaronhunt7204"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <YouTubeIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Blog">
                <IconButton
                  component="a"
                  href="/blog"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <img
                    src="/logo.svg"
                    alt="Custom Icon"
                    style={{ height: 24, width: 24 }}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              width: { md: "50%" },
              boxSizing: "border-box",
              pl: { md: 1 },
            }}
          >
            <Profile />
          </Grid>
        </Grid>
      </DefaultBlock>
      <BlueprintBlock text="render.init portfolioBlock" />
      <DefaultBlock id="work-examples">
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Work Examples
        </Typography>
        <Box className="backgroundGrid">
          <Portfolios />
        </Box>
      </DefaultBlock>
      <BlueprintBlock text="system.load experience animated=true" />
      <DefaultBlock>
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Past Companies
        </Typography>
        <ScrollingLogos
          logos={[
            "/companies/mob.svg",
            "/companies/osg.svg",
            "/companies/gb.png",
            "/companies/fg.svg",
            "/companies/ltt.svg",
            "/companies/dr.svg",
            "/companies/gb.png",
          ]}
        />
      </DefaultBlock>
      <BlueprintBlock text="fetch.content blog articles" />
      <DefaultBlock>
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Articles
        </Typography>
        <BlogColumn showProjects={false} limit={5} />
      </DefaultBlock>
      <BlueprintBlock text="system.load techStack animated=true" />
      <DefaultBlock>
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Technologies
        </Typography>
        <Box sx={{ p: 2 }}>
          <ScrollingLogos
            logos={[
              "/tech/figma.svg",
              "/tech/git.svg",
              "/tech/js.svg",
              "/tech/blender.png",
              "/tech/ue.webp",
              "/tech/ps.svg",
              "/tech/react.webp",
              "/tech/ai.svg",
            ]}
          />
        </Box>

        <Button
          variant="contained"
          color="primary"
          component={RouterLink}
          to="/technologies"
          sx={{ m: 2 }}
          endIcon={<ArrowForwardIosIcon sx={{ height: 14 }} />}
        >
          View More
        </Button>
      </DefaultBlock>
      <BlueprintBlock text="fetch.content blog projects" />
      <DefaultBlock>
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          My Projects
        </Typography>
        <BlogColumn showProjects={true} limit={5} />
      </DefaultBlock>
    </div>
  );
}
